<template>
  <div>
    <p class="sub-title-text-dark">
      {{ $lang.PLAN_DETAILS }}
    </p>
    <v-form ref="subscription_plan_form" lazy-validation @submit.prevent="addAgent()">
      <v-row class="custome-form" justify="start">
        <v-col cols="6" md="4">
          <div>
            <label>{{ $lang.PLAN_TYPE }}</label>

            <v-radio-group v-model="form.plan_type" :disabled="is_edit" row>
              <v-radio :label="$keys.REGULAR_PLAN" :value="$keys.REGULAR_PLAN"></v-radio>
              <v-radio :label="$keys.ADDON_PLAN" :value="$keys.ADDON_PLAN"></v-radio>
              <v-radio :label="$keys.SPECIAL_PLAN" :value="$keys.SPECIAL_PLAN"></v-radio>
            </v-radio-group>
          </div>
          <div>
            <label>{{ $lang.NAME }}</label>
            <v-text-field
                v-model="form.name"
                :disabled="is_edit"
                :placeholder="$lang.NAME"
                :rules="$rules.NAME"
                dense
                outlined
                single-line
            ></v-text-field>
          </div>
          <div>
            <label>{{ $lang.PRICE }}</label>
            <v-text-field
                v-model="form.price"
                :maxlength="6"
                :placeholder="$lang.PRICE"
                :rules="$rules.PRICE"
                dense
                outlined
                single-line
            ></v-text-field>
          </div>
          <div v-if="form.plan_type==$keys.REGULAR_PLAN||form.plan_type==$keys.SPECIAL_PLAN">
            <div>
              <label>{{ $lang.DAYS }}</label>
              <v-text-field
                  v-model="form.validity"
                  :maxlength="3"
                  :placeholder="$lang.DAYS"
                  :rules="$rules.DAYS"
                  dense
                  outlined
                  single-line
              ></v-text-field>
            </div>
            <div>
              <label>{{ $lang.TYPE }}</label>
              <v-select
                  v-model="form.type"
                  :items="subscription_type_option"
                  :placeholder="$lang.TYPE"
                  :rules="$rules.TYPE"
                  dense
                  outlined
                  single-line
              ></v-select>
            </div>
          </div>
          <div v-else>
            <div>
              <label>{{ $lang.ADDON_TYPE }}</label>
              <v-select
                  v-model="addon_type"
                  :items="addon_type_option"
                  :placeholder="$lang.ADDON_TYPE"
                  :rules="$rules.TYPE"
                  dense
                  outlined
                  single-line
              ></v-select>
            </div>
            <div v-if="addon_type==addon_type_option[0]">
              <label>{{ $lang.DAYS }}</label>
              <v-text-field
                  v-model="form.validity"
                  :maxlength="3"
                  :placeholder="$lang.DAYS"
                  :rules="$rules.DAYS"
                  dense
                  outlined
                  single-line
              ></v-text-field>
            </div>
            <div v-if="addon_type==addon_type_option[1]">
              <label>{{ $lang.NO_OF_SHIPMENT_ALLOWED }}</label>
              <v-text-field
                  v-model="form.shipment_count"
                  :maxlength="10"
                  :placeholder="$lang.NO_OF_SHIPMENT_ALLOWED"
                  :rules="$rules.NO_OF_SHIPMENT_ALLOWED"
                  dense
                  outlined
                  single-line
              ></v-text-field>
            </div>
          </div>
        </v-col>
        <!-- BLANK DATA -->
        <v-col class="border-r large-screen " cols="6" md="1">
        </v-col>
        <!--  -->
        <v-col class="pl-5" cols="6" md="4">
          <!--   this section in visile fir the regular and special plan only     -->
          <div v-if="form.plan_type==$keys.REGULAR_PLAN||form.plan_type==$keys.SPECIAL_PLAN">
            <label>{{ $lang.NO_OF_SHIPMENT_ALLOWED }}</label>
            <v-text-field
                v-model="form.shipment_count"
                :maxlength="10"
                :placeholder="$lang.NO_OF_SHIPMENT_ALLOWED"
                :rules="$rules.NO_OF_SHIPMENT_ALLOWED"
                dense
                outlined
                single-line
            ></v-text-field>
          </div>
          <div>
            <label>{{ $lang.GST }}</label>
            <v-text-field
                v-model="form.gst_percent"
                :maxlength="2"
                :placeholder="$lang.GST"
                :rules="$rules.GST"
                dense
                outlined
                single-line
            ></v-text-field>
          </div>
          <div>
            <label>{{ $lang.DESCRIPTION }}</label>
            <v-textarea
                v-model="form.description"
                :placeholder="$lang.DESCRIPTION"
                :rules="$rules.descriptionRule"
                auto-grow
                clearable
                dense
                outlined
                rows="2"
                single-line
            ></v-textarea>
          </div>
          <div>
            <v-btn :loading="btn_loading" color="primary" @click="AddSubscriptionPlan">
              <b>{{ $lang.CONTINUE }}</b>
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-form>

  </div>
</template>
<script>

export default {
  data() {
    return {
      btn_loading: false,
      is_edit: false,
      subscription_plan_id: "",
      subscription_type_option: ['Credit', 'Cash and Credit'],
      addon_type: "",
      addon_type_option: ['Validity Extension', 'Shipment Extension', 'Enable cash delivery'],
      form: {
        plan_type: 'Regular',
        name: "",
        price: "",
        validity: "",
        gst_percent: "",
        type: "",
        description: "",
        shipment_count: "",
      },
    }
  },
  created() {
    /*  show and hide the back btn*/
    if (this.$route.params.subscription_plan_id) {
      this.subscription_plan_id = this.decrypt(this.$route.params.subscription_plan_id)
      this.is_edit = true
      this.getSubscriptionPlanDetails()

    }
  },
  methods: {

    /* fetch wholesaler details */
    getSubscriptionPlanDetails() {
      this.$store.dispatch('setPageLoader', true)
      const self = this
      let params = {
        id: this.subscription_plan_id,
      };

      const successHandler = (response) => {
        if (response.data.success) {
          self.form = response.data.data
          if (self.form.plan_type == self.$keys.ADDON_PLAN) {
            if (self.form.validity > 0)
              self.addon_type = self.addon_type_option[0]
            else if (self.form.shipment_count > 0)
              self.addon_type = self.addon_type_option[1]
            else
              self.addon_type = self.addon_type_option[2]

          }
        }
      };
      const finallyHandler = () => {
        this.$store.dispatch('setPageLoader', false)

      };
      self.request_GET(self, self.$urls.SUBSCRIPTION_PLAN_DETAILS, params, successHandler, null, null, finallyHandler)

    },
    /* Add Edit subscription_plan_form*/
    AddSubscriptionPlan() {
      const self = this
      if (this.$refs.subscription_plan_form.validate() == false)
        return false

      self.btn_loading = true
      var form = new FormData();

      form.append("plan_type", self.form.plan_type);
      form.append("name", self.form.name);
      form.append("price", self.form.price);
      form.append("gst_percent", self.form.gst_percent);
      form.append("description", self.form.description);
      if (self.form.plan_type == this.$keys.REGULAR_PLAN || self.form.plan_type == this.$keys.SPECIAL_PLAN) {
        form.append("validity", self.form.validity);
        form.append("type", self.form.type);
        form.append("shipment_count", self.form.shipment_count);
      } else {
        if (this.addon_type == this.addon_type_option[0])
          form.append("validity", self.form.validity);
        if (this.addon_type == this.addon_type_option[1])
          form.append("shipment_count", self.form.shipment_count);
        if (this.addon_type == this.addon_type_option[2])
          form.append("type", 'Cash and Credit');
      }

      let url = this.$urls.CREATE_SUBSCRIPTON_PLAN
      if (self.is_edit) {
        form.append("id", self.subscription_plan_id);
        url = this.$urls.EDIT_SUBSCRIPTION_PLAN
      }

      const successHandler = (response) => {
        if (response.data.success)
          this.$router.push({name: "manage-subscription-plans"})
      };
      const finallyHandler = () => {
        self.btn_loading = false
      };

      this.request_POST(self, url, form, successHandler, null, null, finallyHandler)


    }
  }

}
</script>